import VisitorClassificationService from './VisitorClassificationService.js'

export const namespaced = true

export const state = {
  classification: null,
}

export const getters = {
  classificationCode: state => state.classification.code,
  classification: state => state.classification,
}

export const mutations = {
  setClassification(state, classification) {
    state.classification = classification
  },
}

export const actions = {
  async maybeFetchFirstClassification(context) {
    if (context.state.classification) {
      return context.state.classification
    } else {
      return await context.dispatch('fetchFirstClassification')
    }
  },
  async fetchFirstClassification(context) {
    const classification = await VisitorClassificationService.getFirstClassification()
    context.commit('setClassification', classification)
    return classification
  },
  async maybeFetchClassification(context, code) {
    if (context.state.classification && context.state.classification.code === code) {
      return context.state.classification
    } else {
      return await context.dispatch('fetchClassification', code)
    }
  },
  async maybeUpdateClassification(context, classificationCode) {
    if (context.state.classification && context.state.classification.code === classificationCode) {
      return await context.dispatch('fetchFirstClassification')
    }
  },
  async fetchClassification(context, code) {
    return await VisitorClassificationService.getClassification(code)
  },
  async fetchSegment(context, { classificationCode, segmentCode }) {
    return await VisitorClassificationService.getSegment(classificationCode, segmentCode)
  },
}
